'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Icon } from '@/components/ui/icon';
import { MinusSignCircleIconSolid, PlusSignCircleIconSolid } from '@/components/ui/icon/glyphs';
import { cn } from '@/lib/ui/utils';
export function TradeDirectionMarker(t0) {
  const $ = _c(11);
  const {
    direction
  } = t0;
  const t = useTranslations("social.debate");
  const isBuy = direction === "buy";
  let t1;
  if ($[0] !== isBuy || $[1] !== t) {
    t1 = isBuy ? t("bought") : t("sold");
    $[0] = isBuy;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isBuy ? "text-feedback-success-accent" : "text-feedback-error-accent";
  let t3;
  if ($[3] !== t2) {
    t3 = cn("absolute -right-1 -bottom-1 rounded-full bg-background-secondary p-px", t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = isBuy ? PlusSignCircleIconSolid : MinusSignCircleIconSolid;
  let t5;
  if ($[5] !== t4) {
    t5 = <Icon icon={t4} className="size-4" aria-hidden={true} />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t1 || $[8] !== t3 || $[9] !== t5) {
    t6 = <span role="img" aria-label={t1} className={t3}>{t5}</span>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}